import React from "react";
import classNames from "classnames";

import "./styles.styl";

export default function FormSection(props) {
  const { className, title, info, children, ...rest } = props;

  return (
    <div className={classNames("form-section", className)}>
      {title && <div className="form-section__title">{title}</div>}
      {info && <div className="form-section__info">{info}</div>}
      {children}
    </div>
  );
}
